import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Header from "../../../Components/Header/Header";
import styles from "../../Style";
import EventTypeModel from "./EventUpdateComponents/EventTypeModel";
import ArtTypeModel from "./EventUpdateComponents/ArtTypeModel";
import AddArtists from "./EventUpdateComponents/AddArtists";
import "react-datepicker/dist/react-datepicker.css";
import GoogleLocation from "./EventUpdateComponents/GoogleLocation";
import DateTimePicker from "./EventUpdateComponents/DateTimePicker";
import AllowArtistsSignUp from "./EventUpdateComponents/AllowArtistsSignUp";
import AutoRepeat from "./EventUpdateComponents/AutoRepeat";
import EventVisibility from "./EventUpdateComponents/EventVisibility";
import EventEntry from "./EventUpdateComponents/EventEntry";
import EventTicketStub from "./EventUpdateComponents/EventTicketStub";
import { validateForm } from "./EventUpdateComponents/validateForm";
import { apiCallGetEventDetails, onAPiCallCreateArtRunnerEvent } from "../../../Core/Apicall";
import { EventUpdataDetails } from "./EventUpdateComponents/EventUpdateDetails";
import { onApiCallUpdata } from "./EventUpdateComponents/onApiCallUpdata";
import { useDispatch, useSelector } from "react-redux";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useFormContext } from "./FormProvider";
import { toast } from "react-toastify";
import moment from "moment";
import dayjs from "dayjs";
const CustomEventRepeat = () => {
  const [EventDetails, setEventDetails] = useState();
  const { formData, setFormData, errors, setErrors } = useFormContext();
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const isProfileData = useSelector((state) => state.isProfileData);
  const onApiCallUserDetails = async () => {
    const param = {
      eventId: location.state.eventId,
    };
    try {
      const response = await apiCallGetEventDetails(param);
      setEventDetails(response.data);
    } catch (error) {
      console.error("API Error:", error);
    }
  };

  const createRepeatEvent = async (payload) => {
    try {
      const response = await onAPiCallCreateArtRunnerEvent(payload);

      if (response?.status === true) {
        toast.success("Event Repeated Successfully 🎉");

        setTimeout(() => {
          navigate(-1);
        }, 1500);
      } else {
        toast.error(response?.message || "Something went wrong");
      }
    } catch (error) {
      toast.error("Failed to create event");
    }
  };

  useEffect(() => {
    if (!EventDetails) return;
    EventUpdataDetails(
      {
        ...EventDetails,
        eventDetail: {
          ...EventDetails?.eventDetail,
          eventDoorOpenTime: null,
          eventEndTime: null,
          eventStartDate: null,
          eventStartTime: null,
          isMidNight: false,

        },
        scheduleEvent: {
          ...EventDetails?.scheduleEvent,
          doRepeat: false,
          endDate: null,
          monthWeek: null,
          nextEvent: null,
          repeatType: null,
          weekDay: null
        }
      },
      setFormData,
      formData
    );

    if (location?.state?.adminEventRepeat) {
      setFormData(prev => ({
        ...prev,
        eventId: ""
      }));
    }
  }, [EventDetails]);

  useEffect(() => {
    if (
      formData.ArtRunner === "Open Mic" ||
      formData.ArtRunner === "Workshop"
    ) {
      setFormData((prevForm) => ({
        ...prevForm,
        PersonallyApprove: true,
      }));
    } else {
      setFormData((prevForm) => ({
        ...prevForm,
        PersonallyApprove: EventDetails?.artistSignupVisibility?.allowArtistSignUp || false,
      }));
    }
  }, [formData.ArtRunner]);



  useEffect(() => {
    if (location?.state?.eventId) {
      onApiCallUserDetails();
    }
  }, [location]);


  const handleSubmit = async () => {

    const isValid = validateForm(
      formData,
      setErrors
    );

    if (!isValid) return;
    const { eventId, ...restFormData } = formData;

    const eventDate = moment(formData.ShowDate).format("YYYY-MM-DD"); // Ensure correct date format
    const eventTime = dayjs(formData.StartTime, "HH:mm").format("HH:mm:ss");
    const utcDate = moment(`${eventDate}T${eventTime}`)
      .utc()
      .format("YYYY-MM-DDTHH:mm:ssZ");

    const payload = {
      eventDetail: {
        eventTypeId: formData.eventTypeId,
        eventName: formData.ShowName,
        eventDescription: formData.ShowDetails,
        eventImages: formData.TicketImages,
        eventStartTimeUTC: utcDate,
        eventPosterImages: formData.EventPoster,
        eventStartDate: moment(formData.ShowDate).format("DD/MM/YYYY"),
        eventStartTime: dayjs(formData.StartTime, "HH:mm").format("HH:mm:ss"),
        eventDoorOpenTime: dayjs(formData.DoorOpens, "HH:mm").format("HH:mm:ss"),
        eventEndTime: dayjs(formData.EndTime, "HH:mm").format("HH:mm:ss"),
        isMidNight: formData.isMidNight,
        isMidNightEndDate: formData.isMidNight
          ? moment(formData.ShowDate).add(1, "days").format("DD/MM/YYYY")
          : moment(formData.ShowDate).format("DD/MM/YYYY"),
        eventVisibility: formData.VisibilityType,
        requirements:
          formData.ArtRunner === "Tour"
            ? null
            : formData.PersonallyApprove === false
              ? null
              : formData.Requirements,
      },
      venueDetail: {
        venueName: formData.VenueName,
        venueAddress: formData.VenueAddress,
      },
      eventMode: {
        categoryId: formData.categoryId,
        bonusSpots: formData.ArtRunner === "Tour" ? null : true,
        noOfSpots:
          formData.ArtRunner === "Tour"
            ? null
            : formData.NumberSpots && formData.PersonallyApprove === false
              ? null
              : formData.NumberSpots,
      },
      personalApproval: {
        allowGuests: formData.ArtRunner === "Tour" ? null : formData.Guests,
        supportVenue:
          formData.ArtRunner === "Tour" ? null : formData.SupportVenue,
        allowMultipleSignup:
          formData.ArtRunner === "Tour" ? null : formData.MultipleSignup,
      },
      preAddedArtist: {
        artistId: formData.AddArtists,
      },
      scheduleEvent: {
        doRepeat: formData.ArtRunner === "Tour" ? null : formData.AutoRepeat,
        repeatType:
          formData.ArtRunner === "Tour"
            ? null
            : formData.AutoRepeat === false || formData.AutoRepeat === null
              ? null
              : formData.RepeatType,
        monthWeek:
          formData.AutoRepeat === false || formData.AutoRepeat === null
            ? null
            : formData.ArtRunner === "Tour"
              ? null
              : formData.RepeatType === "Custom"
                ? formData.WeekMonth
                : null,
        weekDay:
          formData.AutoRepeat === false || formData.AutoRepeat === null
            ? null
            : formData.ArtRunner === "Tour"
              ? null
              : formData.RepeatType === "Custom"
                ? formData.DayWeek
                : null,
        startDate:
          formData.ArtRunner === "Tour"
            ? null
            : formData.RepeatType === false || formData.RepeatType === null
              ? null
              : moment(formData.ShowDate).format("DD/MM/YYYY"),
        nextEvent:
          formData.ArtRunner === "Tour"
            ? null
            : formData.RepeatType === false || formData.RepeatType === null
              ? null
              : formData.RepeatStartDate,
        endDate:
          formData.ArtRunner === "Tour"
            ? null
            : formData.RepeatType === false || formData.RepeatType === null
              ? null
              : moment(formData.RepeatEndDate).format("DD/MM/YYYY"),
      },
      artistSignupVisibility: {
        allowArtistSignUp: formData.ArtRunner === "Showcase" ? formData.PersonallyApprove : true,
        signupVisibility:
          formData.ArtRunner === "Tour" ? null : formData.AlwaysVisible,
        visibilityStartDate:
          formData.AlwaysVisible === 3
            ? moment(formData.CustomDate).format("DD/MM/YYYY")
            : null,
        visibilityStartTime:
          formData.AlwaysVisible === 3
            ? dayjs(formData.CustomTime, "HH:mm").format("HH:mm:ss")
            : null,
        saveSettings: formData.Settings,
      },
      eventPricing: {
        eventEntry: formData.EventEntry,
        VIPPrice: formData.EventEntry === "Free" ? null : formData.VIPPrice,
        VIPSeats: formData.EventEntry === "Free" ? null : formData.VIPSeats,
        economyPrice: formData.EventEntry === "Free" ? null : formData.economyPrice,
        economySeats: formData.EventEntry === "Free" ? null : formData.economySeats,
        latestDateForPurchase: null,
        ticketPageLink: formData.EventEntry === "Free" ? null : formData.PageUrl,
        paymentProvider: formData.EventEntry === "Free" ? "Free" : formData.paymentProvider,
        currency: formData.EventEntry === "Free" ? null : formData.currency,
        exchangeRate: formData.exchangeRate || 1,
        currencySymbol: formData.EventEntry === "Free" ? null : formData.currencySymbol,
        displayEconomyPrice: formData.displayEconomyPrice || null,
        displayVipPrice: formData.displayVipPrice || null,
        freeSeats: formData.freeSeats || null,
      },
      userId: EventDetails?.userId,
      exceptFirst: formData.Expect,
      exceptSecond: formData.Expect1,
      exceptThird: formData.Expect2,
      latitude: formData.latitude,
      longitude: formData.longitude,
      createdBy: "Admin",
      status: "Submit",
    };

    if (location.state.eventId) {
      payload.masterEventId = location.state.eventId;
    }
    await createRepeatEvent(payload);
  };

  const pageTitle = location?.state?.adminEventRepeat === true
    ? "Admin Event Repeat"
    : location?.state?.AdminEvent
      ? "Admin Event Add"
      : location?.state?.adminEventEdit
        ? "Admin Event Edit"
        : "Event Edit";

  return (
    <div>
      <Header name={pageTitle} />
      <div className="EventUpdate" style={styles.EventUpdate}>
        <button className="close_icon" onClick={() => navigate(-1)}>
          X
        </button>
        <div className="modal-content bg-Blue grid p-4 relative">
          <h2>{pageTitle}</h2>
          <form className="p-4 bg-white rounded shadow-md">
            <EventTypeModel />
            <ArtTypeModel />
            <div
              className={`Category_name ${errors.ShowName ? "invalid" : "valid"
                } `}
              style={{ marginBottom: "20px", height: "50px" }}
            >
              <input
                className="Event_input"
                type="text"
                value={formData.ShowName}
                onChange={(e) =>
                  setFormData((prevForm) => ({
                    ...prevForm,
                    ShowName: e.target.value,
                  }))
                }
                placeholder="Show Name"
              />
            </div>

            <div
              className={`Category_name ${errors.ShowDetails ? 'invalid' : 'valid EventUpdateZindex'
                }`}
              style={{ width: '100%', padding: 5, boxSizing: "border-box", marginBottom: "20px", height: 140 }}
            >
              <textarea
                value={formData.ShowDetails || ''}
                onChange={e =>
                  setFormData(prevForm => ({
                    ...prevForm,
                    ShowDetails: e.target.value
                  }))
                }
                placeholder="Show Details"
                style={{
                  maxWidth: '100%',
                  minWidth: '100%',
                  maxHeight: '100%',
                  minHeight: '100%',
                  backgroundColor: 'transparent'
                }}
              ></textarea>
            </div>

            <DateTimePicker />

            <div style={{ fontSize: "12px", marginBottom: "10px" }}>
              Venue Details
            </div>
            <div style={styles.EventDate}>
              <div
                className={`Category_name ${errors.VenueName ? "invalid" : "valid"
                  }`}
                style={{ marginBottom: "10px", width: "100%" }}
              >
                <input
                  type="text"
                  placeholder="Venue Name"
                  className="fontSize16"
                  value={formData.VenueName}
                  onChange={(e) =>
                    setFormData((prevForm) => ({
                      ...prevForm,
                      VenueName: e.target.value,
                    }))
                  }
                />
              </div>
              <GoogleLocation />
            </div>
            <AddArtists />
            {formData.ArtRunner === "Tour" ? (
              ""
            ) : (
              <>
                <AllowArtistsSignUp />
                <AutoRepeat
                  EventDetails={EventDetails}
                  name={"Admin Event Repeat"}
                />
              </>
            )}
            <EventVisibility />
            <EventEntry />
            <EventTicketStub />
            <div
              style={{
                display: "flex",
                gap: "40px",
                maxWidth: "500px",
                margin: "auto",
              }}
            >
              <div onClick={(e) => handleSubmit(e)} style={styles.eventSubmit}>
                Submit
              </div>
            </div>
          </form>
        </div>
      </div>
      <ToastContainer position="top-right" autoClose={3000} />
    </div>
  );
};

export default CustomEventRepeat;
